import { fetchEndpointData } from '@utils/fetchEndpointData';

import type {
  CustomerPortalCreateLocationBody,
  CustomerPortalCreateLocationResponse,
  CustomerPortalLocationListItem,
  CustomerPortalLocationResponse,
} from './endpoints/CustomerPortalLocationsEndpoint.types';

export type CustomerPortalCreatedLocation = CustomerPortalCreateLocationResponse;

export async function fetchCustomerPortalLocations(args: {
  customerId: number;
  cursor?: number;
  take?: number;
  search?: string;
}): Promise<CustomerPortalLocationListItem[]> {
  const searchParams = new URLSearchParams();
  searchParams.append('customerId', args.customerId.toString());
  if (args.cursor != null) {
    searchParams.append('id', args.cursor.toString());
  }
  if (args.take != null) {
    searchParams.append('take', args.take.toString());
  }
  if (args.search) {
    searchParams.append('search', args.search);
  }

  return fetchEndpointData<CustomerPortalLocationListItem[]>(
    `/api/customer-portal/locations?${searchParams.toString()}`,
    { method: 'GET' },
  );
}

export async function fetchCustomerPortalLocation(id: number): Promise<CustomerPortalLocationResponse> {
  return fetchEndpointData<CustomerPortalLocationResponse>(`/api/customer-portal/locations/${id}`, {
    method: 'GET',
  });
}

export async function createCustomerPortalLocation(
  data: CustomerPortalCreateLocationBody,
): Promise<CustomerPortalCreateLocationResponse> {
  return fetchEndpointData<CustomerPortalCreateLocationResponse>('/api/customer-portal/locations', {
    method: 'POST',
    body: data,
  });
}
